import React from "react";
import ParticlesBg from "particles-bg";
import NavArea from "../Home/Header/NavArea";
import { Container } from "reactstrap";
import Footer from "../Footer/Footer";
import Headroom from "react-headroom";
import NotFound from "../../images/undraw_page_not_found_su7k.png";

const NoMatch = () => {
  return (
    <div>
      <ParticlesBg type="random" bg={true} />
      <Headroom
        style={{
          webkitTransition: "all .5s ease-in-out",
          mozTransition: "all .5s ease-in-out",
          oTransition: "all .5s ease-in-out",
          transition: "all .5s ease-in-out",
          background: "#0a192f",
          boxShadow: "1px 1px 1px rgba(0,0,0,0.25)",
        }}
      >
        <Container>
          {" "}
          <NavArea />{" "}
        </Container>
      </Headroom>
      <Container>
        <div>
          <div
            style={{ background: "rgba(255,255,255,0.3)", width: "100%" }}
            className="text-center"
          >
            <h1>
              404, <br /> SORRY FOR BAD REQUEST
            </h1>
            <p>your request will be successful, I am working on it</p>
          </div>
          <img
            style={{ height: "60%", width: "100%" }}
            src={NotFound}
            alt="bad request"
          />
        </div>
      </Container>
      <Footer></Footer>
    </div>
  );
};

export default NoMatch;
